export const header_extension = {
  light: {
    headerbtmborder: {
      color: "#0000000F",
    },
    inputtextcolor: {
      color: "#6b6b6c",
    },
    textcolsecondary: {
      color: "#000000b8",
    },
    textcolprimary: {
      color: "#000",
    },
  },
  dark: {
    headerbtmborder: {
      color: "#FFFFFF0F",
    },
    inputtextcolor: {
      color: "#adaeb3",
    },
    textcolsecondary: {
      color: "#ffffffb8",
    },
    textcolprimary: {
      color: "#fff",
    },
  },
};
